import {
  Button,
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { handlePostProduct } from "../../../services/customerAreaManagement/product";
import { toast } from "material-react-toastify";
import { useStyles } from "./styles";

const CreateDialog = (props) => {
  const [productName, setProductName] = useState();
  const customerId = useSelector((store) => store.auth.customer.customer);
  const classes = useStyles();

  const handleSetUnitName = (name) => {
    setProductName(name);
  };

  const handleCreateProduct = async () => {
    if (!productName) {
      return toast.error("Digite o produto");
    }

    await handlePostProduct(customerId, productName);
    await props.reloadTable();
    props.close();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Produto</DialogTitle>
      <DialogContent>
        <TextField
          onChange={(e) => handleSetUnitName(e.target.value)}
          required
          autoFocus
          margin="dense"
          id="name"
          label="Nome do Produto"
          type="text"
          fullWidth
        />
      </DialogContent>
      <DialogActions className={classes.divFlex}>
        <Button
          onClick={props.close}
          color="primary"
          autoFocus
          className={classes.cancelButtonCreateDialog}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={handleCreateProduct}
          color="primary"
          className={classes.saveButtonCreateDialog}
          variant="contained"
          autoFocus
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateDialog;
